import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './BotItem.module.css'
import { Button, Divider, Dropdown, Flex, message, Modal, Tooltip } from 'antd'
import classNames from 'classnames'
import userIcon from './userIcon.svg'
import { HTTP_URL } from '../../../../util/constants'
import Cookies from 'js-cookie'
import { deleteBotRequest, unpublishBotRequest } from './BotAndDatasetListApi'
import { CheckCircleOutlined, EllipsisOutlined } from '@ant-design/icons'
import shareImgIcon from './shareImg.svg'
export default function BotItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  const [botMenus, setBotMenus] = useState([
    {
      key: '1',
      label: <div>进入智能体</div>,
    },
    {
      key: '2',
      label: <div>编辑</div>,
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '3',
      label: <div>删除</div>,
    },
  ])
  const [botMenus1, setBotMenus1] = useState([
    {
      key: '1',
      label: <div>进入智能体</div>,
    },
    {
      key: '2',
      label: <div>编辑</div>,
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '4',
      label: <div>下架</div>,
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '3',
      label: <div>删除</div>,
    },
  ])
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  // const botClickMethod = (e) => {
  //   e.domEvent.stopPropagation()
  //   console.log(e)
  //   props.botClickMethod(e.key)
  // }
  const botClickMethod = (e) => {
    e.domEvent.stopPropagation()
    let key = e.key
    if (key == 1) {
      window.open(
        HTTP_URL +
          `gongju/preview/index.html?botId=${props.info.bot_id}&icon=${btoa(props.info.icon_url)}&title=${props.info.bot_name}&userToken=${Cookies.get('userToken')}`,
      )
    } else if (key == 2) {
      props.editMethod(props.info)
      // 更新智能体代码
      // setIsShowPage(true)
      // setPersonAgentId(botItem.bot_id)
      // if (botItem.status == 2) {
      //   setShowPublishButton(false)
      // } else {
      //   setShowPublishButton(true)
      // }
    } else if (key == 3) {
      Modal.confirm({
        title: '确认删除',
        content: '确定要删除这条数据吗？删除后不可恢复',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          console.log('用户点击了确定')
          // 在这里调用删除API
          deleteBotRequest(props.info.bot_id, props.info.bot_name, (data) => {
            if (data.ret == 1) {
              props.getBotList()
              message.success('删除成功')
            } else {
              message.error(data.msg)
            }
          })
        },
        onCancel() {
          console.log('用户点击了取消')
        },
      })
    } else if (key == 4) {
      // 下架智能体
      Modal.confirm({
        title: '下架提醒',
        content: '该下架为从教育智能体下架，请确认是否继续',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          console.log('用户点击了确定')
          // 在这里调用下架API
          unpublishBotRequest(props.info.bot_id, (data) => {
            if (data.ret == 1) {
              props.getBotList()
              props.getEduBotList()
              message.success('下架成功')
            } else {
              message.error(data.msg)
            }
          })
        },
        onCancel() {
          console.log('用户点击了取消')
        },
      })
    }
  }
  return (
    <div
      className={classNames(
        styles.background,
        props.index % 4 != 0 ? styles.marginLeft : '',
        parseInt(props.index / 4) > 0 ? styles.marginTop : '',
      )}
      onClick={props.clickBotItem.bind(null, props.info)}
    >
      <div className={styles.TopBox}>
        <img className={styles.headerImg} src={props.info.icon_url} alt="" />
        <Tooltip placement="bottom" title={props.info.bot_name}>
          <div className={styles.botName}>{props.info.bot_name}</div>
        </Tooltip>
        {/* {props.info.status == 2 ? <img className={styles.duigouIcon} src={duigouIcon} alt="" /> : ''} */}
        {props.info.status == 2 ? (
          <CheckCircleOutlined
            style={{ color: '#2772F0' }}
            className={styles.duigouIcon}
          />
        ) : null}
      </div>
      <Tooltip placement="bottom" title={props.info.description}>
        <div className={styles.middleContainer}>{props.info.description}</div>
      </Tooltip>
      <div className={styles.bottomContainer}>
        <Dropdown
          menu={{
            items: props.info.status == 2 ? botMenus1 : botMenus,
            onClick: botClickMethod,
          }}
          trigger={['click']}
          onClick={(e) => {
            e.stopPropagation()
            // setBotItem(item)
            // props.changeBotItem(props.info)
          }}
          className={styles.dropdown}
        >
          <EllipsisOutlined
            style={{ fontSize: '30px', color: '#2772f0', fontWeight: 'bold' }}
          />
        </Dropdown>
        <div className={styles.timeContainer}>
          <img
            className={styles.shareImg}
            src={shareImgIcon}
            alt=""
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              props.shareBotItem(props.info)
            }}
          />
          <img className={styles.userIcon} src={userIcon} alt="" />
          <div>{props.info.open_time}</div>
        </div>
        {/* <div className={styles.nameBox}>@{props.info.name}</div> */}
      </div>
    </div>
  )
}
